import { getYearsFromRange, getRef } from '../../../../utils/functions';

// Motor TT: Process isFileUpload params into normalized file upload objects.
// Used by 20+ params in basicMotorInsurance.json with isFileUpload: true
export const processFileUploadParams = (storeState, params) => {
  const reqObj = {};
  params?.forEach((obj) => {
    if (!obj?.isFileUpload) return;
    const uploads = getRef(storeState, obj.reducerKey) || obj.staticValue;
    const normalized = Array.isArray(uploads)
      ? uploads
          .filter(Boolean)
          .map((u) => ({
            fileId: u?.fileId || u?.id,
            fileName: u?.fileName,
            url: u?.url || u?.fileUrl || u?.fileURL,
            fileUrl: u?.fileUrl || u?.fileURL || u?.url,
            mimeType: u?.mimeType,
          }))
          .filter((u) => u.url || u.fileUrl || u.fileId || u.fileName)
      : undefined;

    if (
      normalized !== undefined &&
      normalized !== null &&
      (normalized.length > 0 || obj?.isAlwaysArray)
    ) {
      reqObj[obj.key] = normalized;
    }
  });
  return reqObj;
};

// Builds the list of selectable manufacture years for vehicle forms.
// Ensures the year range always extends back to at least 1990, even if the
// configured pastYears value in yearManufactureSettings is smaller.
export const getManufacturedYears = (yearManufactureSettings) => {
  return getYearsFromRange({
    ...yearManufactureSettings,
    pastYears: Math.max(
      yearManufactureSettings?.pastYears ?? 0,
      new Date().getFullYear() - 1990,
    ),
  });
};
